import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItFailedSection } from './components/WhyItFailedSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    // Small delay to ensure pixel script is loaded
    const timer = setTimeout(() => {
      trackPageView();
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <WhyItFailedSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <WhatYouGetSection data-id="element-6" />
        <WhoIsForSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <ProofSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <OfferSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}